import PropTypes from 'prop-types'

import { nodePropType } from '../../common/prop-types'

const dietCategoryPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  descriptionUrl: PropTypes.string,
  position: PropTypes.number.isRequired,
  node: nodePropType.isRequired,
})

dietCategoryPropType.defaultProps = {
  description: undefined,
}

export default dietCategoryPropType
